import React, { useEffect, useRef, useState } from "react";
import styled from "@emotion/styled";
import { Colors } from "./colors";
import { useSpring, animated } from "react-spring";
import { mobileWidth } from "./constants";
import { useTranslation } from 'react-i18next';

function Number({ n, isVisible }) {
  const { number } = useSpring({
    from: { number: 0 },
    number: isVisible ? n : 0,
    delay: 100,
    config: { mass: 1, tension: 172, friction: 26 },
  });

  return <AnimatedNumber>{number.to((n) => n.toFixed(0))}</AnimatedNumber>;
}

function roundToFirstDigit(number) {
  const stringNumber = String(number);
  const firstDigit = parseInt(stringNumber.charAt(0));
  return firstDigit * Math.pow(10, stringNumber.length - 1);
}

const SalaryAndCompanyCount = () => {
  const [companiesCount, setCompaniesCount] = useState(0);
  const [salariesCount, setSalariesCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const { t, i18n } = useTranslation();

  const containerRef = useRef();

  useEffect(() => {
    fetch("/api/v1/counts", { credentials: "same-origin" })
      .then((response) => response.json())
      .then((data) => 
        {
          setSalariesCount(data.total_salaries_count)
          setCompaniesCount(data.total_companies_count)
        })
      .catch((error) => console.log(error));

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.5,
      },
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }
  }, []);

  return (
    <Container ref={containerRef}>
      {/* <WhiteCircle>
        <img src="../../static/images/guarantee.gif" alt="glow" />
      </WhiteCircle> */}
      <NumberCol>
        <NumberPlus>
          <Number n={salariesCount} isVisible={isVisible} />
          <Plus>+</Plus>
        </NumberPlus>
        <Label>{t("main_salaries")}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Label>
      </NumberCol>
      <NumberCol>
        <NumberPlus>
          <Number n={companiesCount} isVisible={isVisible} />
          <Plus>+</Plus>
        </NumberPlus>
        <Label>{t("main_companies")}</Label>
      </NumberCol>
    </Container>
  );
};

export default SalaryAndCompanyCount;


const Container = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 20vw;
  padding: 20px 50px 80px 50px;
  margin: 25px 0 -50px 0;
  border-radius: 68px;
  box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.2); /* Use a lighter shadow */
  background: linear-gradient(to left, white, white);
  color: black; /* Text color */
  position: relative;
  align-self: center;
  padding-top: 20px;
  font-size: 2em;
  gap: 30px;
  min-width: 140px;
  @media (max-width: ${mobileWidth}){
      font-size: 1.2em;
  }
`;



const NumberCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: bold;
  position: relative;
`;

const NumberPlus = styled.div`
  display: flex;
  align-items: center;
`;

const Plus = styled.span`
  font-weight: bold;
  margin: 0 5%;
`;

const AnimatedNumber = styled(animated.div)`
`;

const WhiteCircle = styled.div`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(50%, -50%);
  width: 90px;
  height: 90px;
  background-color: white;
  border-radius: 50%;
  border: 2px solid black;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Label = styled.span`
  font-size: 0.75em;
  font-weight: normal;
  margin-top: 1.5em;
  position: absolute;
`;